var map = {
	"./expanded-free-prizes-banner.png": 55388,
	"./expanded-vip-prizes-banner.png": 61187,
	"./free-prizes-banner.png": 65712,
	"./free-prizes-img.png": 8193,
	"./htp-1.png": 96817,
	"./htp-2.png": 72154,
	"./htp-3.png": 93731,
	"./htp-4.png": 63564,
	"./left-active.png": 10561,
	"./left-inactive.png": 33420,
	"./less-icon.png": 5956,
	"./more-icon.png": 15428,
	"./right-active.png": 94806,
	"./right-inactive.png": 15107,
	"./vip-prizes-banner.png": 19471,
	"./vip-prizes-img.png": 316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43880;